import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useConfig from 'app/hooks/useConfig';
import useTheme from 'app/hooks/useTheme';
import { Carousel, ImageWithLoader, NoContent } from 'app/components';
import FavoriteBtn from '../FavoriteBtn';

import {
  Cinema,
  CinemaTitle,
  CinemaDescription,
  CinemaInfo,
  ShadowBoxDark,
  TitleAccent
} from './styles';

const propTypes = {
  cinemas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      favorite: PropTypes.bool.isRequired,
      loyaltyCode: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      cinemaUrlName: PropTypes.string.isRequired,
      address1: PropTypes.string.isRequired,
      image: PropTypes.string,
      address2: PropTypes.string
    })
  ).isRequired
};

const carouselPropsConfig = (desktop, tablet) => ({
  slidesToSlide: 1,
  responsive: {
    desktop: {
      breakpoint: {
        max: 30000,
        min: desktop
      },
      items: 3
    },
    tablet: {
      breakpoint: {
        max: desktop,
        min: tablet
      },
      items: 2
    },
    mobile: {
      breakpoint: {
        max: tablet,
        min: 0
      },
      items: 1
    }
  }
});

const FavoriteCinemas = ({ cinemas }) => {
  const [t] = useTranslation();
  const { routes } = useConfig();
  const theme = useTheme();
  const carouselProps = useMemo(
    () =>
      carouselPropsConfig(
        parseInt(theme.breakPoints.md.width, 10),
        parseInt(theme.breakPoints.sm.width, 10)
      ),
    [theme]
  );

  return (
    <ShadowBoxDark>
      <TitleAccent>{t('cinemas.favorites.title')}</TitleAccent>

      {cinemas && cinemas.length ? (
        <Carousel {...carouselProps}>
          {cinemas.map(({ id, name, cinemaUrlName, address1, address2, image, loyaltyCode, favorite }) => (
            <Cinema key={id}>
              <NavLink to={generatePath(routes.cinemaDetails.pattern, {
                //  id: name.replaceAll(" ", "-")
                id: cinemaUrlName.replaceAll(" ", "-")
              })}>
                <ImageWithLoader type="cinema" imgSrc={image} imgTitle={name} />
              </NavLink>

              <FavoriteBtn id={id} loyaltyCode={loyaltyCode} favorite={favorite} withBookmark />

              <CinemaInfo>
                <CinemaTitle title={name}>{name}</CinemaTitle>
                <CinemaDescription>
                  {[address1, address2].filter(a => a).join(', ')}
                </CinemaDescription>
              </CinemaInfo>
            </Cinema>
          ))}
        </Carousel>
      ) : (
        <NoContent svgId="no-cinema" text={t('cinemas.no_cinemas')} type="account" />
      )}
    </ShadowBoxDark>
  );
};

FavoriteCinemas.propTypes = propTypes;
export default FavoriteCinemas;
